import { useEffect } from "react";

import { keyHelper, isOperatorKey } from "../../utils/key_helper";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by JoinedMeetingScreenIOContextProvider, to provide centralized state management and logic control
export default function useCentralLogicsKeyboard({
  // context managed states and methods
  userHasKeyboard,
  sendKeyboardCommand,
  setKeyboardIconState,
}) {
  useEffect(() => {
    if (userHasKeyboard) {
      // register keyboard events & send commands & set icon

      window.onkeydown = function (e) {
        e.preventDefault();

        sendKeyboardCommand(`kbd ${keyHelper.getKeyCode(e.key).keyCode} 1 1`);
        if (!isOperatorKey(e.key)) sendKeyboardCommand(`kbd ${keyHelper.getKeyCode(e.key).keyCode} 0 1`);

        setKeyboardIconState("key-press");
      };

      window.onkeyup = function (e) {
        if (isOperatorKey(e.key)) sendKeyboardCommand(`kbd ${keyHelper.getKeyCode(e.key).keyCode} 0 1`);

        setKeyboardIconState("key-press");
      };
    } else {
      // unregister keyboard events
      window.onkeydown = null;
      window.onkeyup = null;
    }
  }, [userHasKeyboard, sendKeyboardCommand, setKeyboardIconState]);
}
